module.exports = __webpack_public_path__ + "img/1564666933.826b2a0f.jpg";